




















import Vue from 'vue';
import { IIcons } from '@/common/interfaces/index.interface';
import TIcons from '@/types/TIcons';

interface IFrontpageButtonComponent {
  icons: IIcons;
}

export default Vue.extend({
  name: `FrontpageButton`,
  data(): IFrontpageButtonComponent {
    return {
      icons: TIcons,
    };
  },
  props: {
    borderless: {
      default: false,
      type: Boolean,
    },
    isChristmas: {
      default: false,
      type: Boolean,
    },
    light: {
      default: false,
      type: Boolean,
    },
    text: {
      required: true,
      type: String,
    },
  },
  methods: {
    emitClick(): void {
      this.$emit(`click`);
    },
  },
});
